import { escapeHtml, fmtDate, housePill, propositionLabel, propositionUrl, resultBadge, truncate } from "../format.js";

/**
 * Proposition card (Figma "ID Visual"): tag row (house, type, first subject) with the latest
 * roll-call result on the right, then "PLP 11/2026 · date" and a 3-line italic summary.
 * opts.dateField: "last_roll_call_at" to show the vote date (voted lists), else status/presentation date.
 */
export function renderPropositionCard(p, opts = {}) {
  const date =
    opts.dateField === "last_roll_call_at" && p.last_roll_call_at
      ? { value: p.last_roll_call_at, title: "Data da última votação" }
      : p.status_at
        ? { value: p.status_at, title: "Última atualização" }
        : p.presented_at
          ? { value: p.presented_at, title: "Apresentação" }
          : null;
  const summary = p.summary_one_line || truncate(p.ementa, 260) || "Sem resumo disponível.";
  const subject = (p.subjects || [])[0];
  return `
    <li class="prop-card">
      <a class="prop-card__link" href="${propositionUrl(p)}" data-link>
        <div class="prop-card__top">
          ${housePill(p.house)}
          ${p.type_sigla ? `<span class="pill pill--sage">${escapeHtml(p.type_sigla)}</span>` : ""}
          ${subject ? `<span class="pill">${escapeHtml(subject.label)}</span>` : ""}
          ${resultBadge(p.last_roll_call_result, "pill--result")}
        </div>
        <div class="prop-card__title">
          <span class="prop-card__ident">${escapeHtml(propositionLabel(p))}</span>
          ${date ? `<time class="prop-card__time" datetime="${escapeHtml(date.value)}" title="${date.title}">${fmtDate(date.value)}</time>` : ""}
        </div>
        <p class="prop-card__summary">${escapeHtml(summary)}</p>
        ${p.status_situation ? `<span class="prop-card__status">${escapeHtml(p.status_situation)}</span>` : ""}
      </a>
    </li>`;
}

/** Backwards-compatible name used by the list views. */
export function renderPropItem(p, _i = 0, opts = {}) {
  return renderPropositionCard(p, opts);
}
